




import { defineComponent } from '@vue/composition-api';
// import { useRouter } from '@ideavivat/vivat-2';

import PageColumnWithUserEditor from '@/components/User/PageColumnWithUserEditor.vue';

const Edit = defineComponent({
  components: {
    PageColumnWithUserEditor,
  },
  // setup() { const { route } = useRouter(); return { initRole: route.value.params.initRole, } },
});

export default Edit;
